
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gb",
      function () {
        return require("private-next-pages/gb.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gb"])
      });
    }
  